<div class="text-center presentation">
    <button class="ui button" (click)="initialize()">Initialiser le serveur</button>
    <waiting-popup [waitingMessage]="waitingMessage"
                   [successMessage]="successMessage"
                   [errorMessage]="errorMessage">
    </waiting-popup>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/admin/webmaster/presentation/presentation.html